import React from 'react';
import { ExpandableFilterGroup } from '@ktag/styleguide/dist/react';
import { Attributes, Filter, JobResult } from 'jobs.types';
import useGetFilters from 'javascripts/useGetFilters';

interface Props {
  attributes: Attributes;
  filter: Filter;
  setFilter: (filter: Filter) => void;
  jobs: JobResult[];
}

const JobFilters = ({ attributes, filter, setFilter, jobs }: Props) => {
  const filters = useGetFilters(attributes, jobs, filter, setFilter);

  if (!filters) return null;

  return (
    <div className="jobfilters">
      <ExpandableFilterGroup filters={filters} />
    </div>
  );
};

export default JobFilters;
